import { createPortal } from 'react-dom'

export type BlobProps = {
	size?: 'sm' | 'md' | 'lg' | 'xl'
	color?: 'blue' | 'purple' | 'pink' | 'orange' | 'yellow' | 'green' | 'teal' | 'red'
	style?: React.CSSProperties
	opacity?: number
	blur?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl'
}

export function BlobBlur({
	size = 'md',
	color = 'blue',
	style = { top: '0%', left: '0%' },
	opacity = 50,
	blur = '3xl',
}: BlobProps) {
	const sizes = {
		sm: 'w-64 h-64',
		md: 'w-96 h-96',
		lg: 'w-[28rem] h-[28rem]',
		xl: 'w-[32rem] h-[32rem]',
	}

	const colors = {
		blue: 'radial-gradient(circle, #60a5fa 0%, #3b82f6 50%, transparent 70%)',
		purple: 'radial-gradient(circle, #a78bfa 0%, #8b5cf6 50%, transparent 70%)',
		pink: 'radial-gradient(circle, #f472b6 0%, #ec4899 50%, transparent 70%)',
		orange: 'radial-gradient(circle, #fb923c 0%, #f97316 50%, transparent 70%)',
		yellow: 'radial-gradient(circle, #fbbf24 0%, #f59e0b 50%, transparent 70%)',
		green: 'radial-gradient(circle, #4ade80 0%, #22c55e 50%, transparent 70%)',
		teal: 'radial-gradient(circle, #2dd4bf 0%, #14b8a6 50%, transparent 70%)',
		red: 'radial-gradient(circle, #f87171 0%, #ef4444 50%, transparent 70%)',
	}

	const blurs = {
		sm: 'blur-sm',
		md: 'blur-md',
		lg: 'blur-lg',
		xl: 'blur-xl',
		'2xl': 'blur-2xl',
		'3xl': 'blur-3xl',
	}

	return (
		<div
			className={`absolute ${sizes[size]} rounded-full ${blurs[blur]}`}
			style={{
				background: colors[color],
				opacity: opacity / 100,
				willChange: 'transform',
				...style,
			}}
		/>
	)
}

export function BlobBackground({}) {
	if (typeof document === 'undefined') { return null }

	return createPortal(
		<div
			className="fixed top-0 left-0 -z-10 overflow-hidden h-screen w-screen"
			style={{ backgroundColor: 'white' }}
		>
			<div
				className="fixed inset-0 w-full h-screen"
				style={{
					background: `
          radial-gradient(circle at 10% 20%, rgba(117, 139, 250, 0.13) 0%, transparent 30%),
          radial-gradient(circle at 70% 40%, rgba(162, 132, 252, 0.13) 0%, transparent 30%),
          radial-gradient(circle at 34% 60%, rgba(221, 100, 254, 0.13) 0%, transparent 30%),
          radial-gradient(circle at 90% 80%, rgba(233, 100, 255, 0.13) 0%, transparent 30%),
          #F1F0FA
        `,
				}}
			/>
		</div>,
		document.body,
	)
}
